import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ExportProgressComponent } from './core/export/export-progress.component';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet, ExportProgressComponent],
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
